export default __webpack_public_path__ + "static/chevron-right-3e0c11d51746f497644f4289580e026c.png";